import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'arabicDate'
})
export class ArabicDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) {
      return '';
    }

    const date = moment(value);
    const day = date.format('D');
    const year = date.format('YYYY');
    const month = date.locale('ar').format('MMMM');

    return `${day} ${month} ${year}`;
  }
}
